import React from 'react';
import log from 'loglevel';
import { FixedGrid, FixedGridItem, Paper, PaperSelector } from '../../../ui';

export const Surfaces = () => (
	<>
		<h2 id="surfaces">Surfaces</h2>

		<FixedGrid columns={[3, { mobileXL: 1 }]}>
			<FixedGridItem>
				<Paper>
					<h2>Paper</h2>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, rem
						officia? Quae ad distinctio expedita consectetur molestias
						cupiditate cum nihil nesciunt, ratione labore aspernatur, tempora
						atque aut sequi reiciendis fugit.
					</p>
				</Paper>
			</FixedGridItem>
			<FixedGridItem>
				<PaperSelector
					name="some-selector"
					onChange={(e) => {
						log.debug(e.target.name, '| checked:', e.target.checked);
					}}
				>
					<h2>Paper Selector</h2>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, rem
						officia? Quae ad distinctio expedita consectetur molestias
						cupiditate cum nihil nesciunt, ratione labore aspernatur, tempora
						atque aut sequi reiciendis fugit.
					</p>
				</PaperSelector>
			</FixedGridItem>
		</FixedGrid>
	</>
);
